module.exports = __webpack_public_path__ + "img/pneu.14c9b02d.svg";